import { getOrderFulfillmentCTA } from "./shared";
export var AddOrUpdate = function AddOrUpdate(strictLocalize) {
  return {
    titleBuilder: function titleBuilder() {
      return addOrUpdateBuilder(strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder() {
      return addOrUpdateBuilder(strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getOrderFulfillmentC;
        return (_getOrderFulfillmentC = getOrderFulfillmentCTA(context, strictLocalize)) === null || _getOrderFulfillmentC === void 0 ? void 0 : _getOrderFulfillmentC.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getOrderFulfillmentC2, _getOrderFulfillmentC3;
        return (_getOrderFulfillmentC2 = getOrderFulfillmentCTA(context, strictLocalize)) === null || _getOrderFulfillmentC2 === void 0 ? void 0 : (_getOrderFulfillmentC3 = _getOrderFulfillmentC2.getLink) === null || _getOrderFulfillmentC3 === void 0 ? void 0 : _getOrderFulfillmentC3.call(_getOrderFulfillmentC2);
      }
    }
  };
};
var addOrUpdateBuilder = function addOrUpdateBuilder(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return strictLocalize({
        id: "qfCs6w",
        defaultMessage: [{
          "type": 0,
          "value": "Trackingnummer toevoegen wanneer je zelf verzendt"
        }]
      });
    },
    getDescription: function getDescription() {
      return [strictLocalize({
        id: "UbgtZ8",
        defaultMessage: [{
          "type": 0,
          "value": "Je kunt het trackingnummer toevoegen of bijwerken in Stap 4: Verzendinformatie van de pagina voor bestellingsverwerking. Bekijk de Helpcentrum-artikelen die we hieronder voor je hebben gevonden voor meer gedetailleerde instructies."
        }]
      })];
    }
  };
};